<template id="manager">
    <div class="datacard">
        <div class="datacard-avartar">
            <!--img :src="'/b2b/images/managers/'+manager.email.substring(0, manager.email.indexOf('@'))+'-s.jpg'"-->
            <img :src="(common_res.managers.avartar_prefix!=null?common_res.managers.avartar_prefix:'/b2b/images/managers/')+manager.email.substring(0, manager.email.indexOf('@'))+(common_res.managers.avartar_suffix!=null?common_res.managers.avartar_suffix:'-s.jpg')">
        </div>
        <div class="datacard-data">
            <h3 class="datacard-name">{{manager.name}}</h3>
            <p class="datacard-title" v-if="manager.role=='R'">{{common_res.managers.yourm}}</p>
            <p class="datacard-title" v-else>{{common_res.managers.youam}}</p>
            <div class="datacard-desc" v-if="manager.role=='R'" v-html="common_res.managers.rmmsg"></div>
            <div class="datacard-desc" v-else v-html="common_res.managers.ammsg"></div>
            <div class="datacard-divider"></div>
            <div class="datacard-infoblocks">
            <div class="datacard-infoblock" v-if="manager.phone != null && manager.phone.length >= 8">
                <span class="datacard-caption">{{common_res.managers.direct}}</span>
                <p class="datacard-value">{{manager.phone.indexOf('-') > 0?manager.phone:manager.phone.match(/.{1,4}/g).join("-")}}</p>
            </div>
            <div class="datacard-infoblock" v-if="manager.mobile != null && manager.mobile.length >= 8">
                <span class="datacard-caption">{{common_res.managers.whatsapp}}</span>
                <a class="datacard-value" :href="'https://wa.me/'+(manager.country_code?manager.country_code:'852')+manager.mobile.replace(/^0+/, '')">{{manager.mobile.match(/.{1,4}/g).join("-")}}</a>
            </div>
            <div class="datacard-infoblock full">
                <span class="datacard-caption">{{common_res.managers.email}}</span>
                <a :href="'mailto:'+manager.email" class="datacard-value">{{manager.email}}</a>
            </div>
            </div>

        </div>
    </div>
</template>

<script>

import utils from './Utils.vue'
import Vue from 'vue'

export default {
  name: 'manager',
  props:['manager', 'common_res', 'res', 'locales'],
  data () {
    return {
    }
  },
  components: {
  }
}

</script>


// WEBPACK FOOTER //
// src/components/Manager.vue